import {PHASES} from '../../constants/phases';

// Значения атрибута data-gui-phase на корне экрана матча: по нему токены
// дизайн-системы выбирают цвет фазы (см. src/styles/gameUi/tokens.css)
export const GAME_UI_PHASES = Object.freeze({
  PREP: 'prep',
  SUPPLY: 'supply',
  CONSTRUCTION: 'cons',
  WAR: 'war',
  END: 'end',
  // Рост дохода руин: серый — цвет очков и руин
  RUINS_INCOME: 'ruins',
});

const PHASE_TO_GAME_UI_PHASE = {
  [PHASES.FIELD_PREPARATION]: GAME_UI_PHASES.PREP,
  [PHASES.SETUP]: GAME_UI_PHASES.PREP,
  [PHASES.SUPPLY]: GAME_UI_PHASES.SUPPLY,
  [PHASES.CONSTRUCTION]: GAME_UI_PHASES.CONSTRUCTION,
  [PHASES.WAR]: GAME_UI_PHASES.WAR,
};

/**
 * Фаза интерфейса матча: подготовка (расстановка поля и стартовых кварталов),
 * снабжение, строительство, война или конец игры
 * @param {string} phase - PHASES
 * @param {Object|null} gameResults - итоги партии; есть — игра окончена
 * @param {boolean} [isCityCaptureAnimationPlaying] - идет облет захваченных
 *   городов (scenes/CityCaptureAnimation). Это еще конец войны: следующая фаза
 *   (или итоги партии) в состоянии уже наступила, но интерфейс — цвета войны
 * @param {boolean} [isRuinsIncomeAnimationPlaying] - идет рост дохода руин
 *   (scenes/RuinsIncomeAnimation): интерфейс — цвета очков и руин
 * @returns {string} GAME_UI_PHASES
 */
export const getGameUiPhase = (phase, gameResults, isCityCaptureAnimationPlaying = false, isRuinsIncomeAnimationPlaying = false) => {
  if (isCityCaptureAnimationPlaying) {
    return GAME_UI_PHASES.WAR;
  }
  if (isRuinsIncomeAnimationPlaying) {
    return GAME_UI_PHASES.RUINS_INCOME;
  }
  if (gameResults) {
    return GAME_UI_PHASES.END;
  }
  return PHASE_TO_GAME_UI_PHASE[phase] || GAME_UI_PHASES.PREP;
};
